@import "../../variables.scss";

.bookingDetails {
  &__container {
    display: grid;
    grid-template-rows: auto;
    grid-template-areas:
      "title"
      "back"
      "overview";
    @media (max-width: $size-sm) {
      grid-template-areas:
        "back"
        "title"
        "overview";
    }
    h2 {
      grid-area: title;
    }
    link {
      grid-area: back;
    }
    div {
      grid-area: overview;
    }
  }
  &__wrapper {
    border: 1px #d0d0d0 solid;
    padding: 16px;
    @media (max-width: $size-sm) {
      border: none;
      margin: 0 -16px;
    }
  }
  &__single {
    &:nth-child(1) {
      background-color: rgba(0, 30, 83, 0.1);
    }
  }
  &__weekButton {
    width: 140px;
    height: 40px;
    color: $color-grey;
    background-color: white;
    border-color: #f60;
    @media (max-width: $size-sm) {
      width: 100%;
      text-align: center;
      padding: 0;
    }
    @media (hover: hover) {
      &:hover {
        background-color: #f60;
        color: $color-white;
      }
    }
    &:active {
      background-color: #f60;
      color: $color-white;
    }
  }
  &__titlesection {
    display: flex;
    width: 60%;
    justify-content: space-between;
    @media (max-width: $size-lg) {
      width: 50%;
      flex-direction: column-reverse;
    }
  }
  &__searchbox {
  }
  &__header {
    display: flex;
    width: 100%;
    margin-top: 16px;
    background-color: white;
    &_days {
      width: 100%;
      margin-right: -16px;
    }
    &_vacancy {
      padding-left: 8px;
      width: 23%;
      font-size: 0.88em;
      font-weight: 700;
      letter-spacing: 0.26px;
      @media (max-width: $size-sm) {
        width: 35%;
      }
    }
    &_day {
      font-size: 0.88em;
      font-weight: 700;
      letter-spacing: 0.26px;
      width: 14.28%;
      display: flex;
      justify-content: center;
      @media (max-width: $size-md) {
        width: 100%;
        justify-content: flex-start;
        margin-left: 0;
      }
      &_sun {
        @media (max-width: $size-md) {
          justify-content: flex-end;
          margin-right: 0;
          margin-left: 16px;
          &::after {
            content: "-";
          }
        }
      }
    }
  }
  &__rows {
    margin: 0 -16px 0 -16px;
    &:nth-child(even) {
      background-color: rgba(0, 30, 83, 0.1);
    }
  }
  &__buttonContainer {
    @media (max-width: $size-sm) {
      margin-top: 16px;
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
  &__row {
    display: flex;
    width: 100%;
    height: 60px;
    border-bottom: 1px #dcdcdc solid;
    border-top: 1px #dcdcdc solid;
    &_day {
      align-items: center;
      display: flex;
      justify-content: center;
      &_empty {
        width: 11.42%;
      }
      &_wrapper {
        width: 11.42%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &_vacancy {
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 20%;
      @media (max-width: $size-sm) {
        width: 35%;
      }
      &_inner {
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        letter-spacing: 0.26px;
        font-weight: 700;
        width: 90%;
        padding-left: 16px;
      }
      &_town {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 90%;
        padding-left: 16px;
        color: #666666;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0.23px;
        line-height: 12px;
        margin-bottom: 5px;
      }
    }
  }
  &__filledRow {
    background-color: $color-dark-blue;
    width: 90%;
    height: 20px;
    font-weight: 700;
    color: white;
    @media (max-width: $size-sm) {
      height: 90%;
      letter-spacing: 0;
      line-height: 12px;
      font-size: 10px;
      font-weight: 100;
    }
  }
  &__leftRoundedRow {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    @media (max-width: $size-sm) {
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      height: 90%;
      letter-spacing: 0;
      line-height: 12px;
      font-size: 10px;
      font-weight: 100;
    }
  }
  &__rightRoundedRow {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    @media (max-width: $size-sm) {
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      height: 90%;
      letter-spacing: 0;
      line-height: 12px;
      font-size: 10px;
      font-weight: 100;
    }
  }
}
